import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    ILaunchAmendmentMapped,
    ILaunchAmendmentRaw,
    LaunchAmendmentRaw,
} from "../../types/amendApplication/launchAmendmentTypes"
import { getSchemaMapper } from "../singleApplication/getSchemaMapper"

export const amendApplicationMapper = {
    map: (response: unknown): ILaunchAmendmentMapped => {
        // Validate the raw API response
        const resTyped = tsIoValidate<ILaunchAmendmentRaw>(
            LaunchAmendmentRaw,
            response,
            "Invalid raw launch commissioning form response"
        )

        // Extract form steps and application spec
        const {
            applicationStepIndexMap,
            formTitlesIndexMap,
            applicationForms,
        } = getSchemaMapper.deriveSupportingInfoFromRawSpec(
            resTyped.rawApplicationSpec
        )

        return {
            ...resTyped,
            formTitlesIndexMap,
            applicationStepIndexMap,
            applicationForms,
        }
    },
}
